import React from "react";
import ThemeBtn from "../../components/ThemeBtn/ThemeBtn";
import { useNavigate } from "react-router-dom";
import "./PartnerLandingPage.scss";

function PartnerLandingPage() {
    const navigate = useNavigate();
    sessionStorage.removeItem("SearchResult");
    sessionStorage.removeItem("filter");
    sessionStorage.removeItem("recommendState");
    sessionStorage.removeItem("widget");
    sessionStorage.removeItem("button");




    return (
        <div className="container-landing admin_landingpage">
            <h1 className="text-center admin_heading fw-bold">SOSIALT PLANLEGGINSVERKTØY</h1>
            <div className="d-flex justify-content-center" >
                <p className="text-center col-md-10 mb-4 text-uppercase-subheading">ET GODT SOSIALT TILBUD TILTREKKER TALENT, FORBEDRER ARBEIDSMILJØET OG ØKER TRIVSELEN BLANT DE ANSATTE. <br />NÅ ER DET ENKELT Å PLANLEGGE GØYE AKTIVITETER Å GJØRE SAMMEN MED TEAMET, LEDERGRUPPEN ELLER HELE KONTORET!</p>
            </div>

            <div className="mb-4" >
                <img style={{width:"100%"}}  src="partnerDash.png" />
            </div>

            <div className="body-landing">
                <div className="item-landing w-50">
                    <h3 className="text-center fw-bolder mb-10">PLANLEGGING</h3>
                    {/*<ThemeBtn*/}
                    {/*    onClick={() => {*/}
                    {/*        navigate("/orderplan/add2");*/}
                    {/*    }}*/}
                    {/*    BtnClass="Theme_btn_primary "*/}
                    {/*    BtnText="FINN ENGANGSAKTIVITET"*/}
                    {/*/>*/}

                    <ThemeBtn
                        onClick={() => {


                            navigate("/orderplan/rec1");
                        }}
                        BtnClass="Theme_btn_primary "
                        BtnText="VELG 1 AKTIVITET"
                    />


                    <ThemeBtn
                        onClick={() => {


                            navigate("/orderplan/rec2");
                        }}
                        BtnClass="Theme_btn_primary "
                        BtnText="BYGG SOSIAL KALENDER"
                    />

                    {/*<ThemeBtn*/}
                    {/*    onClick={() => {*/}
                    {/*        navigate("/orderplan/edit1");*/}
                    {/*    }}*/}
                    {/*    BtnClass="Theme_btn_primary "*/}
                    {/*    BtnText="REDIGER ENGANGSAKTIVITET"*/}
                    {/*/>*/}



                    {/*<ThemeBtn*/}
                    {/*    onClick={() => {*/}
                    {/*        navigate("/orderplan/all");*/}
                    {/*    }}*/}
                    {/*    BtnClass="Theme_btn_primary "*/}
                    {/*    BtnText="SE ALLE "*/}
                    {/*/>*/}
                </div>
                {/*<div className="item-landing">*/}
                {/*    <h3 className="text-center fw-bolder">PLANLEGG FREMOVER </h3>*/}
                {/*    */}{/*<ThemeBtn*/}
                {/*    */}{/*    onClick={() => {*/}
 

                {/*    */}{/*        navigate("/orderplan/add2");*/}
                {/*    */}{/*    }}*/}
                {/*    */}{/*    BtnClass="Theme_btn_primary "*/}
                {/*    */}{/*    BtnText="LAG SOSIAL KALENDER"*/}
                {/*    */}{/*/>*/}

                {/*    <ThemeBtn*/}
                {/*        onClick={() => {*/}


                {/*            navigate("/orderplan/rec2");*/}
                {/*        }}*/}
                {/*        BtnClass="Theme_btn_primary "*/}
                {/*        BtnText="FÅ ANBEFALT KALENDER"*/}
                {/*    />*/}

                {/*    */}{/*<ThemeBtn*/}
                {/*    */}{/*    onClick={() => {*/}
                           
                {/*    */}{/*        navigate("/orderplan/edit2");*/}
                {/*    */}{/*    }}*/}
                {/*    */}{/*    BtnClass="Theme_btn_primary "*/}
                {/*    */}{/*    BtnText="REDIGER SOSIAL KALENDER"*/}
                {/*    */}{/*/>*/}


                {/*    */}{/*<ThemeBtn*/}
                {/*    */}{/*    onClick={() => {*/}
                {/*    */}{/*     navigate("/orderplan/all");*/}
                {/*    */}{/*    }}*/}
                {/*    */}{/*    BtnClass="Theme_btn_primary "*/}
                {/*    */}{/*    BtnText="SE ALLE"*/}
                {/*    */}{/*/>*/}
                {/*</div>*/}
                <div className="item-landing w-50">
                    <h3 className="text-center fw-bolder mb-10">AKTIVITETER</h3>
                    {/*<ThemeBtn*/}
                    {/*    onClick={() => {*/}
                            
                    {/*        navigate("/orderplans/singlestatus");*/}
                    {/*    }}*/}
                    {/*    BtnClass="Theme_btn_primary "*/}
                    {/*    BtnText="SE ENKEL BESTILLINGER"*/}
                    {/*/>*/}
                    {/*<ThemeBtn*/}
                    {/*    onClick={() => {*/}
                            
                    {/*        navigate("/orderplans/multistatus");*/}
                    {/*    }}*/}
                    {/*    BtnClass="Theme_btn_primary "*/}
                    {/*    BtnText="SE ÅRSHJUL BESTILLINGER"*/}
                    {/*/>*/}
                    <ThemeBtn
                        onClick={() => {
                            navigate("/bestilllagre");
                        }}
                        BtnClass="Theme_btn_primary "
                        BtnText="SE LAGREDE AKTIVITETER"
                    />

                    <ThemeBtn
                        onClick={() => {

                            navigate("/bestillingsdetaljer");
                        }}
                        BtnClass="Theme_btn_primary "
                        BtnText="SE FORESPØRSLER"
                    />

                    




                    {/*<ThemeBtn*/}
                    {/*    onClick={() => {*/}
                          
                    {/*        navigate("/orderplan");*/}
                    {/*    }}*/}
                    {/*    BtnClass="Theme_btn_primary "*/}
                    {/*    BtnText="SE ALLE "*/}
                    {/*/>*/}
                </div>
                </div>
        </div>
    );
}

export default PartnerLandingPage;